import { createStore, update } from '@kundinos/nanostores';
import { useStore } from '@kundinos/nanostores/react';

export interface PopupsData {
  opened: boolean;
}

export const popupsStore = createStore<PopupsData>(() => {
  popupsStore.set({ opened: false });
});

export const openPopup = () => {
  update(popupsStore, (prev) => ({ ...prev, opened: true }));
};

export const closePopup = () => {
  update(popupsStore, (prev) => ({ ...prev, opened: false }));
};

export const usePopups = (): Readonly<PopupsData> => {
  return { ...useStore(popupsStore) };
};

export default {
  openPopup,
  closePopup,
};
